import React from 'react';
import TileCollectionHeader from './components/TileCollectionHeader';
import TileCollectionRow from './components/TileCollectionRow';

import { useTileCollection } from './hooks';
import { Loading } from './Loading';

type TileCollectionProps = {
  collection: string;
};

const TileCollection = ({ collection }: TileCollectionProps) => {
  const { data, loading, error } = useTileCollection(collection);
  if (loading) {
    return <Loading />;
  }

  if (!data?.tiles?.length || error) {
    return null;
  }

  return (
    <>
      <TileCollectionHeader
        data-testid="tile-collection-header"
        swooshName={data.title}
      >
        {data.title}
      </TileCollectionHeader>
      <TileCollectionRow title={data.title} tiles={data.tiles} />
    </>
  );
};

export default TileCollection;
